export default __webpack_public_path__ + "static/media/7b03744073c33fe3bd2ddfe3342928df1600263079703.1fbefda2.webp";